import { render, staticRenderFns } from "./px-step-by-step-dialog.vue?vue&type=template&id=ae83d252&scoped=true&"
import script from "./px-step-by-step-dialog.vue?vue&type=script&lang=ts&"
export * from "./px-step-by-step-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./px-step-by-step-dialog.vue?vue&type=style&index=0&id=ae83d252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae83d252",
  null
  
)

export default component.exports